<div id="main" class="col-xs-12">
  <app-breadcrumb
    currentPage="Cessão de Crédito"
    routerCurrentPage="/cessao"
    voltar="hide"
  ></app-breadcrumb>

  <div id="records" class="row options-row">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <h2 id="descricao-cessa" class="record-title" >Cessão de Crédito</h2>
        </div>
      </div>

      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" [ngClass]="{ active: isAguardandoAssinatura }">
          <a
            href="#aguardando"
            (click)="onClickEmAguardandoAssinatura()"
            aria-controls=""
            role="tab"
            data-toggle="tab"
          >
            Liberação dos Termos de Cessão
            <span *ngIf="isPesquisandoCessaoNaoAssinadaLoader">
              <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
            </span>
          </a>
        </li>

        <li role="presentation" [ngClass]="{ active: isAssinado }">
          <a
            href="#assinadas"
            (click)="onClickTermoCessaoAprovado()"
            aria-controls=""
            role="tab"
            data-toggle="tab"
          >
            Termos de Cessão Aprovados
            <span *ngIf="isPesquisandoCessaoAprovadaLoader">
              <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
            </span>
          </a>
        </li>

        <li class="align-right refresh-item">
          <a class="filters" (click)="onClickChangePage(page?.number)">
            <span class="fa fa-refresh"></span>Recarregar
          </a>
        </li>

        <li class="align-right filter-item">
          <a
            class="filters"
            (click)="openFilter = !openFilter"
            [ngClass]="{ 'text-blue': openFilter }"
          >
            <span class="fa fa-search"></span> Buscar Fichas
          </a>
        </li>
      </ul>

      <form
        #filterForm="ngForm"
        (ngSubmit)="filtrar(filterForm)"
        *ngIf="openFilter"
        class="filter-panel"
      >
        <div class="filter-group">
          <div>
            <label class="text-blue" for="filtroProposta">Proposta</label>
            <input
              id="filtroProposta"
              type="text"
              class="form-control"
              name="proposta"
              placeholder="Digite aqui para pesquisar..."
              minlength="8"
              ngModel
              #proposta="ngModel"
            />
          </div>

          <div>
            <label class="text-blue" for="filtroCpf">CPF</label>
            <input
              id="filtroCpf"
              type="text"
              class="form-control"
              name="cpf"
              placeholder="Digite aqui para pesquisar..."
              mask-number
              mask="999.999.999-99"
              minlength="11"
              ngModel
              #cpf="ngModel"
            />
          </div>

          <div>
            <label class="text-blue" for="filtroContrato">Contrato</label>
            <input
              id="filtroContrato"
              type="text"
              class="form-control"
              name="contrato"
              placeholder="Digite aqui para pesquisar..."
              minlength="15"
              ngModel
              #contrato="ngModel"
            />
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-full-orange"
          [disabled]="
            (!proposta.value && !cpf.value && !contrato.value) ||
            !filterForm.valid
          "
        >
          Buscar
        </button>
      </form>
    </div>
  </div>

  <div *ngIf="contratos.length === 0 && isAguardandoAssinatura">
    <h4 class="text-center">
      Não existem fichas pendentes para aprovação de cessão de crédito
    </h4>
  </div>

  <div *ngIf="contratos.length === 0 && liberado">
    <h4 class="text-center">
      Não encontramos nenhum termo de cessão aprovado com os valores digitados,
      tente novamente.
    </h4>
  </div>

  <div *ngIf="contratos.length > 0">
    <div class="custom-select">
      <div>
        Mostrar:
        <select (change)="changePageSize($event.target.value)">
          <option
            [value]="selectedSize"
            *ngFor="let selectedSize of sizeSelection; let i = index"
            [selected]="i == 0"
          >
            {{ selectedSize }}
          </option>
        </select>
        registros
      </div>
    </div>

    <table class="table table-striped" aria-describedby="descricao-cessa">
      <thead>
        <tr class="text-blue">
          <th scope="col" *ngIf="!clickouAssinado" class="checkbox-column">
            <input
              class="form-check-input"
              type="checkbox"
              id="checkboxNoLabel"
              value=""
              aria-label="..."
              [(ngModel)]="selecionados"
              (change)="selecionaTodos()"
            />
          </th>

          <th scope="col" (click)="sort('proposta')" class="cursor-pointer">
            <span
              *ngIf="key === 'proposta'"
              class="fa"
              [ngClass]="{
                'fa-arrow-up': reverse,
                'fa-arrow-down': !reverse
              }"
            >
            </span>
            PROPOSTA
          </th>

          <th scope="col" (click)="sort('cpfCliente')" class="cursor-pointer">
            <span
              *ngIf="key === 'cpfCliente'"
              class="fa"
              [ngClass]="{
                'fa-arrow-up': reverse,
                'fa-arrow-down': !reverse
              }"
            >
            </span>
            CPF CLIENTE
          </th>

          <th scope="col" (click)="sort('contrato')" class="cursor-pointer">
            <span
              *ngIf="key === 'contrato'"
              class="fa"
              [ngClass]="{
                'fa-arrow-up': reverse,
                'fa-arrow-down': !reverse
              }"
            >
            </span>
            CONTRATO
          </th>

          <th scope="col" (click)="sort('emissao')" class="cursor-pointer">
            <span
              *ngIf="key === 'emissao'"
              class="fa"
              [ngClass]="{
                'fa-arrow-up': reverse,
                'fa-arrow-down': !reverse
              }"
            >
            </span>
            EMISSÃO
          </th>

          <th scope="col" (click)="sort('cnpj')" class="cursor-pointer">
            <span
              *ngIf="key === 'cnpj'"
              class="fa"
              [ngClass]="{
                'fa-arrow-up': reverse,
                'fa-arrow-down': !reverse
              }"
            >
            </span>
            CNPJ
          </th>

          <th scope="col" class="sign-column"></th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let contrato of contratos | filter: filter | orderBy: key:reverse
          "
          class="cessao-table"
          [ngClass]="{ selected: contrato.selecionado }"
        >
          <td class="checkbox-column" *ngIf="!clickouAssinado">
            <input
              class="form-check-input"
              type="checkbox"
              id="checkboxNoLabel"
              value="{{ contrato.contrato }}"
              aria-label="..."
              [(ngModel)]="contrato.selecionado"
              (change)="isTodosSelecionados()"
            />
          </td>
          <td>{{ contrato.proposta }}</td>
          <td>{{ contrato.cpfCliente | cpf }}</td>
          <td>{{ contrato.contrato }}</td>
          <td>{{ contrato.emissao | datetime }}</td>
          <td>{{ contrato.cnpj | cnpj }}</td>
          <td class="sign-column" *ngIf="!clickouAssinado">
            <button
              class="icon cessao-documento-assinar lined"
              (click)="onClickAssinar(contrato)"
            ></button>
          </td>
          <td class="sign-column" *ngIf="clickouAssinado">
            <div class="d-flex">
              <button
                class="icon cessao-documento-visualizar"
                (click)="onClickVisualizar(contrato)"
              ></button>
              <button
                class="icon cessao-documento-imprimir"
                (click)="onClickImprimir(contrato)"
              ></button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-xs-4">
        <div *ngIf="page && contratosCessaoSelecionados.length < 2">
          Mostrando: {{ page.number * page.size + 1 }} até
          <Span> {{ page.number * page.size + page.numberOfElements }} </Span>
          de
          <span> {{ page.totalElements }} </span>
        </div>
      </div>

      <div class="col-xs-4" *ngIf="contratosCessaoSelecionados.length < 2">
        <div class="pagination-container" *ngIf="page && page.totalPages > 0">
          <nav aria-label="Page navigation">
            <ul class="pagination m-0">
              <li class="page-item" [ngClass]="page.first ? 'disabled' : ''">
                <a
                  class="page-link cursor-pointer"
                  (click)="
                    page.first ? null : onClickChangePage(page.number - 1)
                  "
                  aria-label="Previous"
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>

              <li
                class="page-item"
                *ngFor="let pageAux of page.pages"
                [ngClass]="pageAux == page.number ? 'active' : ''"
                [ngClass]="i == page.number ? 'active' : ''"
              >
                <a
                  class="page-link cursor-pointer"
                  (click)="onClickChangePage(pageAux)"
                  >{{ pageAux + 1 }}</a
                >
              </li>

              <li class="page-item" [ngClass]="page.last ? 'disabled' : ''">
                <a
                  class="page-link cursor-pointer"
                  (click)="
                    page.last ? null : onClickChangePage(page.number + 1)
                  "
                  aria-label="Next"
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div *ngIf="aprovarEmLote" class="approve-btn">
        <div>
          {{ contratosCessaoSelecionados.length }} Termos de Cessão selecionados
        </div>
        <a class="btn btn-full-orange" (click)="onClickAprovarEmLote()"
          >Aprovar termos em lote</a
        >
      </div>
    </div>
  </div>
</div>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
